module.exports = __webpack_public_path__ + "static/media/julesCle.3140bccd.png";